export const DRAWER_WIDTH = 288;
export const HEADER_HEIGHT_DESKTOP = 60;
export const HEADER_HEIGHT_DESKTOP_WITH_GLOBAL_ALERT = HEADER_HEIGHT_DESKTOP;
export const HEADER_HEIGHT_MOBILE = 50;
export const HEADER_HEIGHT_MOBILE_WITH_GLOBAL_ALERT = 200;
export const HEADER_PRIVATE_LAYOUT = 125;

// Typography
export const FONT_SIZE_XXS = 8;
export const FONT_SIZE_XS = 10;
export const FONT_SIZE_SMALL = 12;
export const FONT_SIZE_SMALLISH = 14;
export const FONT_SIZE_INBETWEEN = 15;
export const FONT_SIZE_MEDIUM = 16;
export const FONT_SIZE_MEDIUM_INBETWEEN = 17;
export const FONT_SIZE_MEDIUM_CONFUSED = 18;
export const FONT_SIZE_LARGISH = 20;
export const FONT_SIZE_LARGE = 22;
export const FONT_SIZE_X_LARGE = 24;
export const FONT_SIZE_LARGER = 26;
export const FONT_SIZE_HUGE = 29;
export const FONT_SIZE_XX_LARGER = 32;

// Z-Index
export const Z_INDEX_PRIVATE_LAYOUT_NAV_BAR = 1203;
export const Z_INDEX_PRODUCT_TOUR_OVERLAY = 1251;
export const Z_INDEX_PRODUCT_TOUR = 1252;
